import React from 'react';
import * as $ from 'jquery';
import useHttp from '../../../../../hook/use-http';
import { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomSelect_RangeAnalysis from "./CustomSelect_RangeAnalysis"
import styles from './Filter_RangeAnalysis.module.css'
import "./styles.css"
import { useRangeAnalysisVehicleData } from '../Context';

export default function BDT_Filter(props) {
  const { GlobalData, setGlobalData } = useRangeAnalysisVehicleData()

  const inputRef = useRef(null);

  const formatDateForDisplay = (date) => {
    return date ? moment(date).format('MMM D, YYYY') : '';
  };

  useEffect(() => {
    if (GlobalData.startDate) {
      const today = moment();
      const fiveYearsAgo = moment().subtract(5, 'years');
      const defaultStart = moment(GlobalData.startDate);
      const defaultEnd = moment(GlobalData.endDate);

      $(inputRef.current).daterangepicker(
        {
          startDate: defaultStart,
          endDate: defaultEnd,
          minDate: fiveYearsAgo,
          maxDate: today,
          showDropdowns: true,
          autoUpdateInput: false,
          singleMonthMode: true,
          linkedCalendars: false,
          locale: {
            format: 'MMMM D, YYYY',
            applyLabel: 'Apply',
            separator: ' - ',
            cancelLabel: '',
          },
        }
      );

      $(inputRef.current).on('show.daterangepicker', function (ev, picker) {
        picker.container.addClass('ms_ace');
      });

      $(inputRef.current).on('apply.daterangepicker', function (ev, picker) {
        const start = picker.startDate.format("YYYY-MM-DD");
        const end = picker.endDate.format("YYYY-MM-DD");

        $(this).val(
          picker.startDate.format('MMMM D, YYYY') + ' - ' + picker.endDate.format('MMMM D, YYYY')
        );

        setGlobalData(prev => ({
          ...prev,
          startDate: start,
          endDate: end,
        }));
        props.onsubmit(prev => ({
          ...prev,
          startDate: start,
          endDate: end,
        }));
      });

      // Optional: clear input on cancel
      $(inputRef.current).on('cancel.daterangepicker', function () {
        $(this).val('');
        setGlobalData(prev => ({
          ...prev,
          startDate: null,
          endDate: null,
        }));
      });
    }

    return () => {
      if ($(inputRef.current).data('daterangepicker')) {
        $(inputRef.current).data('daterangepicker').remove();
        $(inputRef.current).off('.daterangepicker');
      }
    };
  }, []);

  return (
    <>
      <div className="card mb-3 p-3">
        <div className="row">

          {/* Wider Date Range */}
          <div className="col-md-3">
            <div className={`mb-1 ${styles.date_range_selection}`}>Date Range</div>
            <div className="input-group mt-1">
              <input
                type="text"
                ref={inputRef}
                className={`form-control ${styles.customDateRangePicker}`}
                placeholder="Select date range"
                value={
                  GlobalData.startDate && GlobalData.endDate
                    ? `${formatDateForDisplay(GlobalData.startDate)} - ${formatDateForDisplay(GlobalData.endDate)}`
                    : ''
                }
                readOnly
              />
            </div>
          </div>

          {/* Other inputs */}
          <div className="col-md-9">
            {/* <CustomSelect_RangeAnalysis setGlobalFilter={setGlobalData} ></CustomSelect_RangeAnalysis> */}
          </div>
        </div>
      </div>
    </>
  )
}